import {
  Component,
  computed,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-service-progress-bar',
  templateUrl: './service-progress-bar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ServiceProgressBarComponent {
  readonly inService = input(0);

  readonly pending = input(0);

  readonly total = computed(() => this.inService() + this.pending());

  readonly inServicePercentage = computed(() =>
    this.total() > 0 ? (this.inService() / this.total()) * 100 : 0,
  );

  readonly pendingPercentage = computed(() =>
    this.total() > 0 ? (this.pending() / this.total()) * 100 : 0,
  );
}
